module.exports = __webpack_public_path__ + "assets/5052ae5d02e57010f42442c9ed6d9a58.svg";